import { objectWithoutPropertiesLoose as _objectWithoutPropertiesLoose } from './_virtual/_rollupPluginBabelHelpers.js';
import { getUserLocales } from 'get-user-locale';
import currency from 'currency.js';
import CURRENCIES from './currencies.js';

var _excluded = ["locales"];
var cache = new WeakMap();
var format = function format(_ref) {
  var _ref$currencyCode = _ref.currencyCode,
    currencyCode = _ref$currencyCode === void 0 ? 'USD' : _ref$currencyCode,
    amount = _ref.amount,
    _ref$locales = _ref.locales,
    locales = _ref$locales === void 0 ? getUserLocales() : _ref$locales,
    _ref$symbol = _ref.symbol,
    symbol = _ref$symbol === void 0 ? true : _ref$symbol,
    _ref$zeroDecimals = _ref.zeroDecimals,
    zeroDecimals = _ref$zeroDecimals === void 0 ? false : _ref$zeroDecimals;
  amount = parseInt(amount, 10) || 0;
  try {
    var _currencyCode;
    currencyCode = ((_currencyCode = currencyCode) !== null && _currencyCode !== void 0 ? _currencyCode : 'USD').toLocaleUpperCase();
  } catch (error) {
    console.error('Error with converting currency code', error);
    currencyCode = 'USD';
  }
  if (!CURRENCIES[currencyCode]) {
    currencyCode = 'USD';
  }
  if (!Array.isArray(locales)) {
    locales = [locales];
  }
  var _CURRENCIES$currencyC = CURRENCIES[currencyCode],
    precision = _CURRENCIES$currencyC.decimal_digits,
    symbol_native = _CURRENCIES$currencyC.symbol_native;
  var _currency = currency(amount, {
      fromCents: true,
      precision: precision
    }),
    value = _currency.value;
  var formattedCurrency;
  try {
    var options = {
      locales: locales
    };
    if (symbol) {
      options.style = 'currency';
      options.currency = currencyCode;
      options.currencyDisplay = 'symbol';
    }
    if (!cache.has(options)) {
      var _locales = options.locales,
        currencyOptions = _objectWithoutPropertiesLoose(options, _excluded);
      // Sorted locales because of en-US should be first because it's the default for US dollars
      cache.set(options, new Intl.NumberFormat(_locales.sort(), currencyOptions));
    }
    var formatter = cache.get(options);
    formattedCurrency = formatter.format(value);
    var conditions = [{
      condition: function condition(currencyString) {
        var lastThree = currencyString.substring(currencyString.length - 3);
        return lastThree === '.00';
      },
      action: function action(currencyString) {
        return currencyString.substring(0, currencyString.length - 3);
      }
    }];
    if (!zeroDecimals) {
      formattedCurrency = conditions.reduce(function (currencyString, condition) {
        if (condition.condition(currencyString)) {
          return condition.action(currencyString);
        }
        return currencyString;
      }, formattedCurrency);
    }
  } catch (error) {
    console.log('Error with formatting currency: ', error);
    formattedCurrency = "" + symbol_native + value;
  }
  return formattedCurrency;
};

export { format as default };
//# sourceMappingURL=format.js.map
